import { lazy } from 'react';

export const InitPage = lazy(() => import('./ui/InitPage/InitPage'));
